import React from 'react';
import { PageContentWrapper } from 'app/layouts/wrapper/page-content';
import { Route, Routes } from 'react-router-dom';
import { AllIntegrations } from './all';

const IntegrationsModule = () => {
  return (
    <PageContentWrapper>
      <Routes>
        <Route path="*" element={<AllIntegrations />} />
      </Routes>
    </PageContentWrapper>
  );
};

export default IntegrationsModule;
